export function selectCommentsById(state, commentsById = []) {
  const result = [];
  const commentsData = selectCommentsData(state);
  commentsById.forEach((commentId) => result.push(commentsData[commentId]));
  return result;
}

export function selectFeedById(feedData, feedId) {
  return feedData[feedId];
}

export function selectFeedDataById(state, feedId) {
  return selectFeedById(selectAllFeedData(state), feedId);
}

export function selectFeedIds(state) {
  return state.feed.result;
}

export function selectAllFeedData(state) {
  return state.feed.entities.posts;
}

export function selectCommentsData(state) {
  return state.feed.entities.comments;
}

export function selectCommentsIdsForFeed(feedData) {
  return feedData.comments || [];
}

export function selectCommentsForFeed(state, feedId) {
  const feedsData = selectAllFeedData(state);
  const feedData = selectFeedById(feedsData, feedId);
  if (!feedData) return [];
  const commentsIds = selectCommentsIdsForFeed(feedData);
  return selectCommentsById(state, commentsIds);
}

export function selectFeedItemCommentsLength(state, feedId) {
  return selectCommentsForFeed(state, feedId).length;
}

export function selectFeedItemMedia(state, feedId) {
  const feedData = selectFeedDataById(state, feedId);
  return feedData.media || [];
}

export function selectReactionsOfFeedItem(state, feedId) {
  const feedData = selectFeedDataById(state, feedId);
  return feedData.reactions;
}

export function selectCanPerformReactions(state, feedId) {
  const feedData = selectFeedDataById(state, feedId);
  return feedData.actions.reactions;
}

export function selectFeedItemType(state, feedId) {
  const feedData = selectFeedDataById(state, feedId);
  return feedData.type;
}

export function selectDataForPostFeedItem(state, feedId) {
  const feedData = selectFeedDataById(state, feedId);
  return {
    id: feedData.id,
    employeeImage: feedData.fromEmployee.getProfileImage(),
    employeeName: feedData.fromEmployee.fullName,
    employeeId: feedData.fromEmployee.id,
    text: feedData.text,
    macrosRes: feedData.macrosRes,
    contentState: feedData.contentState,
    media: feedData.media,
    landingPageDetails: feedData.landingPage,
    reason: feedData.reason,
  };
}

export function selectFeedItemReason(state, feedId) {
  const feedData = selectFeedDataById(state, feedId);
  return feedData ? feedData.reason : {};
}

export function selectLandingPageDetailsForFeedItem(state, feedId) {
  const feedData = selectFeedDataById(state, feedId);
  return feedData.landingPage;
}
